export const state = {
  purchaseorders: [],
  systemPurchaseorder: [],
  purchaseorder: [],
  
  systemPurchaseorderItem: [],
  purchase_order_items: [
    {
      product_id: "",
      product_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remarks: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/purchaseorders/state.js